














import {Vue, Component} from 'vue-property-decorator';
import UpdateApp from "@/components/UpdateApp.vue";
import NetworkProblem from "@/components/NetworkProblem.vue";
import ConfirmBeforeLeaving from "@/components/ConfirmBeforeLeaving.vue";

@Component({
  components: {
    NetworkProblem,
    UpdateApp,
    ConfirmBeforeLeaving
  },
})
export default class App extends Vue {

}

